<template>
    <header class="player-stats-hero">
        <div class="hero-main">
            <div class="hero-avatar">
                <img v-if="player?.photo_url" :src="player.photo_url" :alt="player.full_name" />
                <span v-else class="avatar-placeholder">{{ initials }}</span>
            </div>
            <div class="hero-info">
                <h1 class="hero-name">{{ player?.full_name }}</h1>
                <div class="hero-meta">
                    <span v-if="player?.number" class="hero-badge">#{{ player.number }}</span>
                    <span v-if="positionLabel" class="hero-badge hero-badge--muted">{{ positionLabel }}</span>
                    <component
                        :is="teamPublicPath(player) ? 'a' : 'span'"
                        v-if="player?.team"
                        :href="teamPublicPath(player) || undefined"
                        class="hero-team"
                        :class="{ 'hero-team--link': !!teamPublicPath(player) }"
                    >
                        <img v-if="player.team_logo" :src="player.team_logo" alt="" class="team-logo" />
                        {{ player.team }}
                    </component>
                </div>
                <p v-if="seasonLabel" class="hero-subtitle">Статистика за {{ seasonLabel }}</p>
            </div>
        </div>
        <div class="hero-actions">
            <Link href="/profile" class="hero-link">Профиль</Link>
        </div>
    </header>
</template>

<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';
import { POSITION_NAMES } from '@/utils/playerStatsCalculator';
import { teamPublicPath } from '@/utils/teamUrl';

const props = defineProps({
    player: { type: Object, default: () => ({}) },
    seasonName: { type: String, default: '' },
    positionSlug: { type: String, default: null },
});

const initials = computed(() => props.player?.full_name?.charAt(0) || '?');
const positionLabel = computed(() =>
    props.player?.position || POSITION_NAMES[props.positionSlug] || null
);
const seasonLabel = computed(() => props.seasonName || '');
</script>
